SNI.Application.addModule('shopping-promo', (context) => {
  return {
    behaviors: ['lazy-load', 'multi-component-dynamic-ad', 'affiliate']
  };
});
